import React, { useState } from 'react'
import Update from '../assets/iconUpdate.svg'
import avatarUniSexe from '../assets/avatarUniSexe.svg'
import classNames from 'classnames'
import ImageUserUpdate from 'containers/SettingProfileContainer/imageUserUpdate'
import {
  avatar1, avatar10, avatar11,
  avatar12, avatar13, avatar14,
  avatar15, avatar16, avatar17,
  avatar18, avatar19, avatar2, avatar20, avatar21,
  avatar22, avatar23, avatar24, avatar27,
  avatar28, avatar3, avatar4, avatar5,
  avatar6, avatar7, avatar8, avatar9,
} from 'assets/avatar'

const dataAvatar = [
  { index: 1, image: avatar1 },
  { index: 2, image: avatar2 },
  { index: 3, image: avatar3 },
  { index: 4, image: avatar4 },
  { index: 5, image: avatar5 },
  { index: 6, image: avatar6 },
  { index: 7, image: avatar7 },
  { index: 8, image: avatar8 },
  { index: 9, image: avatar9 },
  { index: 10, image: avatar10 },
  { index: 11, image: avatar11 },
  { index: 12, image: avatar12 },
  { index: 13, image: avatar13 },
  { index: 14, image: avatar14 },
  { index: 15, image: avatar15 },
  { index: 16, image: avatar16 },
  { index: 17, image: avatar17 },
  { index: 18, image: avatar18 },
  { index: 19, image: avatar19 },
  { index: 20, image: avatar20 },
  { index: 21, image: avatar21 },
  { index: 22, image: avatar22 },
  { index: 23, image: avatar23 },
  { index: 24, image: avatar24 },
  { index: 27, image: avatar27 },
  { index: 28, image: avatar28 },
]
interface Props {
  setAvatar?: (val: number) => void
  avatar: any
  border?: string
  styleCss?: string
  name?: string
  num?: string
  afficheName?: boolean
  styleName?: string
  lastName?: string
  ifUpdate?: boolean
  shadow?: string
  onSave?: (avatarId: number) => Promise<void>
}

const Avatar: React.FC<Props> = ({
  avatar,
  border,
  styleCss,
  name,
  num,
  setAvatar,
  styleName,
  shadow,
  afficheName = false,
  lastName,
  ifUpdate = false,
  onSave,
}) => {
  const [updateImageBenef, setUpdateImageBenef] = useState(false)

  const matchedAvatar = dataAvatar.find((v) => v.index === avatar)
  return (
    <div
      className={`${border} ${afficheName ? 'flex w-full gap-6 xl:gap-4 items-center' : ' flex-col items-center justify-center '} `}
    >
      <div className={` ${shadow} overflow-hidden  ${ifUpdate && 'relative'}`}>
        <img
          className={classNames(styleCss)}
          width={100}
          height={100}
          src={matchedAvatar ? matchedAvatar?.image : avatarUniSexe}
          alt="avatar"
        />

        {ifUpdate && (
          <div
            className="absolute bottom-0 left-0 w-full h-1/2 bg-[#5754E5] opacity-75 rounded-b-full flex items-center justify-center cursor-pointer"
            onClick={() => setUpdateImageBenef(true)}
          >
            <img src={Update} alt="" />
          </div>
        )}
      </div>
      {afficheName ? (
        <div className="text-[18px] xl:text-[15px] ">
          <div className=" text-[#0A0A0A] font-inter text-[18px] font-medium "> {name}</div>
          <div className="text-[#B4B4B4]  ">{num}</div>
        </div>
      ) : (
        <div className={`${styleName} text-[#0A0A0A] cursor-default font-medium text-center text-[14px] `}>
          {lastName?.slice(0, 6)}
        </div>
      )}

      {setAvatar && (
        <ImageUserUpdate
          isOpen={updateImageBenef}
          closeModal={() => setUpdateImageBenef(false)}
          newImage={avatar}
          setNewImage={setAvatar}
          dataAvatar={dataAvatar}
          updateAvatar={onSave}
        />
      )}
    </div>
  )
}

export default Avatar
